export default __webpack_public_path__ + "static/media/mood-spectrum.4e7c61ce.jpg";